export enum DiscountTypeEnum {
    Percent = 'Percent',
    Sum = 'Sum'
}
